export enum AgendaSlotType {
  BLOCKED = "BLOCKED",
  RESERVED = "RESERVED",
  AVAILABLE = "AVAILABLE"
}
